import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  InvoiceSettings,
  UpdateInvoiceSettingsRequest,
  InvoiceSettingsResponse,
  NipValidationResponse,
  VatValidationResponse,
} from "../types/invoiceSettings.types";

export class InvoiceSettingsService extends BaseService {
  async getSettings(): Promise<ApiResult<InvoiceSettingsResponse>> {
    return this.handleRequest<InvoiceSettingsResponse>(
      this.client.get("/api/admin/settings/invoice"),
    );
  }

  async updateSettings(
    request: UpdateInvoiceSettingsRequest,
  ): Promise<ApiResult<InvoiceSettings>> {
    return this.handleRequest<InvoiceSettings>(
      this.client.put("/api/admin/settings/invoice", request),
    );
  }

  async validateNip(nip: string): Promise<ApiResult<NipValidationResponse>> {
    return this.handleRequest<NipValidationResponse>(
      this.client.get(
        `/api/admin/settings/invoice/validate-nip/${encodeURIComponent(nip)}`,
      ),
    );
  }

  async validateVat(
    countryCode: string,
    vatNumber: string,
  ): Promise<ApiResult<VatValidationResponse>> {
    return this.handleRequest<VatValidationResponse>(
      this.client.get(
        `/api/admin/settings/invoice/validate-vat/${encodeURIComponent(countryCode)}/${encodeURIComponent(vatNumber)}`,
      ),
    );
  }
}
